<template>
  <div>
    <Modal
      class="editBlock depalist"
      v-model="modal"
      :title="newstructureStatus ?'创健部门':'编辑部门'"
      width="25"
      footer-hide
      :styles="{top: '20%'}"
    >
      <div class="bodyhigh">
        <div class="bodyfirst">
          <div class="content">
            <Row>
              <Col span="24" class="necessary">
                <div>
                  <label>
                    <span>*</span>部门名称
                  </label>
                  <Input v-model="depaname" class="editInput comapny-name" type="text"></Input>
                  <p v-if="exit">名稱重複</p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div v-if="!newstructureStatus" class="btn" @click="editClasSubmit">儲存</div>
          <div v-else class="btn" @click="addConfirm">儲存</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalStructure",
  props: {
    structureStatus: {
      type: Boolean,
      required: true
    },
    newstructureStatus: Boolean,
    depa: Object,
    depalist: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      depaname: '',
      exit: false,
      tempodepa: {},

    }
  },
  computed: {
    ...mapGetters(['username']),
    modal: {
      get () {
        return this.structureStatus
      },
      set (val) {
        this.reset()
        this.$emit("update:structureStatus", val)
        this.$emit("update:depa", '')
        this.$emit("update:newstructureStatus", false)
      }
    }
  },
  watch: {
    depa () {
      this.tempodepa = JSON.parse(JSON.stringify(this.depa))
      this.depaname = this.tempodepa.depaname
    }
  },
  methods: {
    //提交确定
    addConfirm () {
      this.exit = false;
      this.depalist.forEach(i => {
        if (i.depaname === this.depaname.trim()) this.exit = true;
      });
      if (this.exit) return;
      this.$axios
        .insdepa({ maid: this.username.maid, depaname: this.depaname.trim() })
        .then(res => {
          this.$emit("getDepartment")
        })
        .catch(err => console.error(err))
      this.modal = false
    },

    //編輯分類確認送出
    editClasSubmit () {
      let obj = {
        maid: this.username.maid,
        depaid: this.depa.depaid,
        depaname: this.depaname
      };
      this.$axios
        .upddepa(obj)
        .then(res => {
          this.$emit("getDepartment")
          this.$emit("filterDepalsit")
        })
        .catch(err => console.error(err))
      this.modal = false
    },
    reset () {
      this.depaname = ''
      this.depaid = ''
    }
  }
}
</script>
<style lang="less">
.editBlock.depalist {
  .ivu-input {
    width: 70%;
  }
  p {
    color: var(--main-red);
    margin-left: 80px;
    margin-top: -5px;
    font-size: 6px;
  }
}
</style>